import { Navigate, Route, Routes } from 'react-router-dom';
import Shell from './ui/Shell';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Parola from './pages/Parola';
import Stok from './pages/Stok';
import UrunKarti from './pages/UrunKarti';
import YeniUrun from './pages/YeniUrun';
import Fason from './pages/Fason';
import Tahsilat from './pages/Tahsilat';
import BorcHatirlatma from './pages/BorcHatirlatma';
import Kasa from './pages/Kasa';
import CekSenet from './pages/CekSenet';
import Krediler from './pages/Kredi';
import Donem from './pages/Donem';
import NakitAkis from './pages/NakitAkis';
import Teklif from './pages/Teklif';
import Alis from './pages/Alis';
import Siparis from './pages/Siparis';
import SiparisDetay from './pages/SiparisDetay';
import Crm from './pages/Crm';
import Cari360 from './pages/Cari360';
import Bugun from './pages/Bugun';
import Numune from './pages/Numune';
import Ayarlar from './pages/Ayarlar';
import KayitIzi from './pages/KayitIzi';
import Kilavuz from './kilavuz/Kilavuz';
import Fihrist from './pages/Fihrist';
import TeklifDetay from './pages/TeklifDetay';
import FasonPortal from './pages/FasonPortal';
import Sunum from './pages/Sunum';
import Finans from './pages/Finans';
import Destek from './pages/Destek';
import { RaporFinans, RaporMusteriler, RaporSatis, RaporSiparisler, RaporStok, RaporTahsilatRiski, RaporTemsilciler, RaporUrunler } from './pages/Raporlar';
import SiteGenelBakis from './pages/site/SiteGenelBakis';
import SiteOzellestir from './pages/site/SiteOzellestir';
import { SiteBlog, SiteYazi } from './pages/site/SiteBlog';
import SiteGorseller from './pages/site/SiteGorseller';
import { SiteProje, SiteProjeler } from './pages/site/SiteProjeler';
import SiteAyarlar from './pages/site/SiteAyarlar';
import SiteYayinGecmisi from './pages/site/SiteYayinGecmisi';
import TelegramSayfasi from './ui/TelegramAyar';
import { useAuth } from './lib/auth';
import { BaglantiYok } from './pwa/Pwa';

export default function App() {
  const { me, loading, can, baglantiYok, yenidenDene } = useAuth();

  /**
   * Fasoncu portalı kimlik duvarının ÖNÜNDE: fasoncular sistem kullanıcısı
   * değil, yetkileri adresteki token. Giriş ekranına düşerlerse link işe
   * yaramaz.
   */
  if (window.location.pathname.startsWith('/f/')) {
    return (
      <Routes>
        <Route path="/f/:token" element={<FasonPortal />} />
      </Routes>
    );
  }

  // Açılışta sunucuya ulaşılamadı: oturum durur, "Bağlantı yok" ekranı yeniden denetir.
  if (!me && baglantiYok) return <BaglantiYok yenidenDene={yenidenDene} bekliyor={loading} />;

  if (loading) {
    return (
      <div className="ccd">
        <div className="ccd-authwrap"><div className="ccd-inline-note">Yükleniyor…</div></div>
      </div>
    );
  }
  if (!me) return <Login />;

  return (
    <Routes>
      <Route path="/sunum" element={<Sunum />} />
      {/* Tema düzenleyici tam ekrandır: kabuğun (menü + üst şerit) dışında açılır. */}
      {can('settings.write') && <Route path="/site/ozellestir" element={<SiteOzellestir />} />}
      <Route element={<Shell />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/parola" element={<Parola />} />
        {/* Kişisel Telegram bağlantısı ve bildirim tercihleri: ayarlar yetkisi gerekmez. */}
        <Route path="/telegram" element={<TelegramSayfasi />} />
        <Route path="/stok" element={<Stok />} />
        {can('product.write') && <Route path="/stok/yeni" element={<YeniUrun />} />}
        <Route path="/stok/:id" element={<UrunKarti />} />
        <Route path="/teklif" element={<Teklif />} />
        <Route path="/teklif/:id" element={<TeklifDetay />} />
        <Route path="/tahsilat" element={<Tahsilat />} />
        {/* Borç hatırlatma: rota yalnız görebilen role; diğerleri ana sayfaya döner. */}
        {can('reminder.view') && <Route path="/tahsilat/hatirlatma" element={<BorcHatirlatma />} />}
        {/* Kasa ve banka: rota yalnız görebilen role; diğerleri ana sayfaya döner (API'de de `cash.view`). */}
        {can('cash.view') && <Route path="/kasa" element={<Kasa />} />}
        {can('cash.view') && <Route path="/kasa/nakit-akisi" element={<NakitAkis />} />}
        {/* Çek / senet ve krediler: rotalar yalnız görebilen role (API'de de `cheque.view` / `loan.view`). */}
        {can('cheque.view') && <Route path="/cek-senet" element={<CekSenet />} />}
        {can('loan.view') && <Route path="/kredi" element={<Krediler />} />}
        {/* Dönemler (yıl devri): rota yalnız görebilen role (API'de de `period.view`). */}
        {can('period.view') && <Route path="/donem" element={<Donem />} />}
        <Route path="/fason" element={<Fason />} />
        <Route path="/alis" element={<Alis />} />
        <Route path="/siparis" element={<Siparis />} />
        <Route path="/siparis/:id" element={<SiparisDetay />} />
        <Route path="/finans" element={<Finans />} />
        {/* Raporlar yalnız parayı görebilen role: rota da yoktur, yetkisiz kullanıcı ana sayfaya döner. */}
        {can('receivable.view') && (
          <>
            <Route path="/rapor" element={<Navigate to="/rapor/satis" replace />} />
            <Route path="/rapor/satis" element={<RaporSatis />} />
            <Route path="/rapor/musteriler" element={<RaporMusteriler />} />
            <Route path="/rapor/urunler" element={<RaporUrunler />} />
            <Route path="/rapor/finans" element={<RaporFinans />} />
            <Route path="/rapor/tahsilat-riski" element={<RaporTahsilatRiski />} />
            <Route path="/rapor/siparisler" element={<RaporSiparisler />} />
            <Route path="/rapor/temsilciler" element={<RaporTemsilciler />} />
            {can('quote.cost') && <Route path="/rapor/stok" element={<RaporStok />} />}
          </>
        )}
        <Route path="/destek" element={<Destek />} />
        <Route path="/crm" element={<Crm />} />
        <Route path="/crm/:id" element={<Cari360 />} />
        <Route path="/bugun" element={<Bugun />} />
        <Route path="/numune" element={<Numune />} />
        {/* Ayarlar ikinci düzey paneldir: her bölüm kendi adresinde. Eski `/ayarlar#vade` bağlantıları sayfanın içinde yönlenir. */}
        <Route path="/ayarlar" element={<Ayarlar />} />
        <Route path="/ayarlar/:bolum" element={<Ayarlar />} />
        <Route path="/kayit-izi" element={<KayitIzi />} />
        <Route path="/kilavuz" element={<Kilavuz />} />
        <Route path="/fihrist" element={<Fihrist />} />
        {/* Site yönetimi yalnız yöneticiye: rota da yoktur, yetkisiz kullanıcı ana sayfaya döner. */}
        {can('settings.write') && (
          <>
            <Route path="/site" element={<SiteGenelBakis />} />
            <Route path="/site/blog" element={<SiteBlog />} />
            <Route path="/site/blog/:id" element={<SiteYazi />} />
            <Route path="/site/projeler" element={<SiteProjeler />} />
            <Route path="/site/projeler/:id" element={<SiteProje />} />
            <Route path="/site/gorseller" element={<SiteGorseller />} />
            <Route path="/site/ayarlar" element={<SiteAyarlar />} />
            <Route path="/site/yayin-gecmisi" element={<SiteYayinGecmisi />} />
            {/* Eski adresler yeni karşılıklarına yönlenir. */}
            <Route path="/site/genel" element={<Navigate to="/site/ayarlar" replace />} />
            <Route path="/site/anasayfa" element={<Navigate to="/site/ozellestir" replace />} />
            <Route path="/site/yayin" element={<Navigate to="/site/yayin-gecmisi" replace />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
